import { ArrowRight, CalendarClock } from "lucide-react";
import { smoothScrollTo } from "../../hooks/useLenis";

export default function BookCallBanner() {
  const goToContact = (e) => {
    e.preventDefault();
    smoothScrollTo("contact", -60);
  };

  return (
    <section
      id="book"
      data-testid="book-call-banner"
      className="relative border-t border-white/10 py-20 sm:py-24"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="relative overflow-hidden bg-slate-900 border border-white/10 rounded-sm p-10 sm:p-14 lg:p-16">
          <div
            aria-hidden
            className="absolute inset-0 opacity-[0.07]"
            style={{
              backgroundImage:
                "linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)",
              backgroundSize: "60px 60px",
            }}
          />
          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
            <div className="lg:col-span-8">
              <div className="flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-emerald-300/80 font-bold">
                <CalendarClock className="w-4 h-4" />
                Book a call
              </div>
              <h2 className="mt-5 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-white">
                See exactly what ProCliniq would recover for{" "}
                <span className="text-slate-400">your clinic.</span>
              </h2>
              <p className="mt-6 text-base leading-relaxed text-slate-400 max-w-2xl">
              30 minutes. We look at your current call flow, website
              traffic and dormant enquiry list, then build a tailored ROI
              model — no obligation.
            </p>
            </div>
            <div className="lg:col-span-4 flex lg:justify-end">
              <a
                href="#contact"
                onClick={goToContact}
                data-testid="book-call-cta"
                className="inline-flex items-center justify-center gap-2 bg-white text-slate-950 hover:bg-slate-200 transition-colors font-medium rounded-sm px-7 py-4 text-sm whitespace-nowrap"
              >
                Book a call
                <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
